import { ColumnValue, FilterValue, IColumnDefinition } from "./PCSTableTypes";

export function calculateColumns<T extends object>(items: T[]): IColumnDefinition<T>[] {
	let fieldNames: string[] = [];
	items.forEach((i) => {
		const keys = Object.keys(i);
		keys.forEach((j) => {
			if (!fieldNames.includes(j)) {
				fieldNames.push(j);
			}
		});
	});

	return fieldNames.map<IColumnDefinition<T>>((i) => ({
		columnId: i,
		headerText: i,
		getValue: (item: any) => ((item[i] as any) ?? "")?.toString(),
	}));
}

export function getFilterValues<T extends object>(
	items: T[],
	column: IColumnDefinition<T>
): FilterValue[] {
	if (!column.filterable) return [];

	return items
		.map<FilterValue>((i) => {
			return getColumnFilterValue(i, column);
		})
		.filter((val, index, array) => {
			return array.findIndex((j) => j.key === val.key) === index;
		})
		.sort((a, b) => a.label.localeCompare(b.label));
}

export function getColumnValue<T>(item: T, column: IColumnDefinition<T>) {
	const val: ColumnValue = column.getValue ? column.getValue(item) : (item as any)[column.columnId];
	return val;
}

export function getColumnFilterValue<T>(item: T, column: IColumnDefinition<T>) {
	if (column.getFilterValue) {
		return { ...column.getFilterValue(item), columnId: column.columnId };
	} else {
		const val: ColumnValue = getColumnValue(item, column);
		return {
			key: val?.toString() ?? "",
			label: val?.toLocaleString() ?? "(Empty)",
			value: val,
			columnId: column.columnId,
		};
	}
}
